module.exports = __webpack_public_path__ + "img/Retirada restos de poda no pomar.8f5f5021.webp";